export default {"src":"/_next/static/media/individual.ca9aa8d1.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};